"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AbcNotValidError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.default = AbcNotValidError;
